import React, { useState, useEffect } from "react";
import { v4 as uuidv4 } from "uuid";
import { useHistory } from "react-router";
import { GridRowModes } from "@mui/x-data-grid";
import { Tooltip } from "@mui/material";
import { Card, Input, Container, Row } from "reactstrap";

import { putpost, putpost2 } from "services/http";
import { endpoint } from "../../common/constant";
import { ReactComponent as BackIcon } from "assets/img/svg/BackButton.svg";

import CustomButton from "components/CustomButton";
import AInput from "../../common/formFeilds/customInput/AInput";
import { ReactComponent as ActiveControl } from "assets/img/svg/ActiveControl.svg";
import { ReactComponent as InactiveControl } from "assets/img/svg/InactiveControl.svg";

import AChip from "../../common/chip/AChip";
import { isObjEmpty } from "../pincode/constants";
import { AGridColDef } from "../../common/data-grid/ADataGridColDef";
import ADataGrid from "views/pages/manage/common/data-grid/EnhanceDataGrid";
import { LastUpdatedDetails } from "../../employeeManagement/userProfile/helper";
import { editCellContainerStyle } from "../../edpOps/stockManagement/mastersAndMapping/onBoardingMaterialIdSetup/constant";
import {
  failureToast,
  successToast,
} from "../../common/utils/methods/toasterFunctions/function";
import { capitalize } from "../../common/utils/methods/commonMethods/utilityMethod";

import { NEW_EMPTY_ROW, REGEX_DISP_VAL, getSubjects } from "./helper";

const SubjectTable = ({ userPermissions, setIsLoading }) => {
  const history = useHistory();

  const [apiResponse, setApiResponse] = useState([]);
  const [rowData, setRowData] = useState([]);
  const [rowForm, setRowForm] = useState({});
  const [rowModesModel, setRowModesModel] = useState({});
  const [totalRows, setTotalRows] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);

  const [isSaveVisible, setisSaveVisible] = useState(false);
  const [pageSize, setPageSize] = useState(50);

  const [userSearchInput, setUserSearchInput] = useState("");

  useEffect(() => {
    fetchAllSubjects();
  }, []);

  useEffect(() => {
    setRowData(apiResponse);
  }, [apiResponse]);

  const fetchAllSubjects = async (
    page = 0,
    pageSize,
    searchVal = userSearchInput
  ) => {
    setIsLoading(true);

    const response = await getSubjects(page, pageSize, searchVal);

    if (response?.totalPage) {
      const { subjectMasterList, totalRecords } = response;
      setApiResponse(subjectMasterList);
      // setRowData(content);
      setTotalRows(totalRecords);
    }
    setIsLoading(false);
  };

  const rowFormHandler = (value, key) => {
    setRowForm((prev) => ({ ...prev, [key]: value }));
  };

  const startEditing = (id, form) => {
    setRowModesModel((oldModel) => ({
      [id]: { mode: GridRowModes.Edit, fieldToFocus: "subjectDispValue" },
    }));

    setRowForm(form);
  };

  const stopEditing = (id) => {
    const currForm = { ...rowForm };

    setRowModesModel((oldModel) => ({
      [currForm?.id]: { mode: GridRowModes.View, ignoreModifications: true },
    }));
    setRowForm({});
  };

  const columns = [
    new AGridColDef("subjectDispValue", "Display Value")
      .setFlex(0.3)
      .columnAlign("center")
      .editable(true)
      .renderCellComponent((params) =>
        params?.value ? (
          <Tooltip title={params?.value}>
            <div className="ellipsis-text-container">{params?.value}</div>
          </Tooltip>
        ) : (
          <div className="m-auto">-</div>
        )
      )
      .renderEditCellComponent((params) => (
        <div style={editCellContainerStyle}>
          <Input
            maxLength="50"
            defaultValue={rowForm?.subjectDispValue}
            onChange={(e) => {
              rowFormHandler(e.target.value, "subjectDispValue");
            }}
            placeholder="Display Value"
            className="tdInput"
          />
        </div>
      )),

    new AGridColDef("subjectDesc", "Description")
      .setMinWidth(300)
      .editable(true)
      .renderCellComponent((params) =>
        params?.value ? (
          <Tooltip title={params?.value}>
            <div className="ellipsis-text-container">{params?.value}</div>
          </Tooltip>
        ) : (
          <div className="m-auto">-</div>
        )
      )
      .renderEditCellComponent((params) => {
        return (
          <div style={editCellContainerStyle}>
            <Input
              maxLength="250"
              defaultValue={rowForm?.subjectDesc}
              onChange={(e) => {
                rowFormHandler(e.target.value, "subjectDesc");
              }}
              placeholder="Description"
              className="tdInput"
            />
          </div>
        );
      }),

    new AGridColDef("updatedOn", "Last Updated On")
      .setFlex(0.5)
      .columnAlign("left")
      .editable(false)
      .renderCellComponent((params) =>
        params?.value ? (
          <Tooltip
            title={LastUpdatedDetails(params?.value, params?.row.updatedBy)}
          >
            <div className={`ellipsis-text-container`}>
              {LastUpdatedDetails(params?.value, params?.row.updatedBy)}
            </div>
          </Tooltip>
        ) : (
          <div className="m-auto">-</div>
        )
      ),

    new AGridColDef("status", "Status")
      .setFlex(0.2)
      .columnAlign("center")
      .editable(true)
      .renderCellComponent((params) => (
        <AChip
          label={capitalize(params?.value)}
          success={params.value?.toUpperCase() === "ACTIVE"}
        />
      ))
      .renderEditCellComponent((params) => {
        return (
          <div style={editCellContainerStyle} className="text-center">
            <span>
              {rowForm?.status?.toUpperCase() === "ACTIVE" ? (
                <ActiveControl
                  onClick={() => rowFormHandler("INACTIVE", "status")}
                />
              ) : (
                <InactiveControl
                  onClick={() => rowFormHandler("ACTIVE", "status")}
                />
              )}
              <span className="ml-1">Active</span>
            </span>
          </div>
        );
      }),

    new AGridColDef("actions", "Action", false)
      .setFlex(0.3)
      .pinColumnLast(true)
      .renderCellComponent((params) =>
        params.api.getRowMode(params?.id) === "view" ? (
          <>
            <CustomButton
              content={""}
              permissionType={"U"}
              icon={true}
              forTable={true}
              onClick={() => {
                handleEditClick(params);
              }}
              permissionSet={userPermissions}
            />

            <CustomButton
              content={""}
              permissionType={"D"}
              icon={true}
              forTable={true}
              onClick={() => {
                deleteRow(params.id);
              }}
              permissionSet={userPermissions} // for SuperAdmins only
            />
          </>
        ) : (
          <>
            <CustomButton
              content={"Save"}
              permissionType={"C,U"}
              icon={false}
              forTable={true}
              onClick={() => {
                // stopEditing(rowId);
                saveAll(params.row.id);
              }}
              permissionSet={userPermissions}
            />
            <CustomButton
              content={""}
              permissionType={"cancel"}
              icon={true}
              forTable={true}
              onClick={() => {
                handleCancelClick(params);
              }}
              permissionSet={userPermissions}
            />
          </>
        )
      ),
  ];

  const newRow = () => {
    if (!isObjEmpty(rowForm)) {
      failureToast("Please Delete or Save current changes");
    } else {
      let randomId = uuidv4();
      let emptyRow = {
        ...NEW_EMPTY_ROW,
        id: randomId,
      };
      startEditing(randomId, emptyRow);
      setRowData((prev) => [emptyRow, ...prev]);
      setisSaveVisible(true);
    }
  };

  const handleEditClick = (params) => {
    if (!isObjEmpty(rowForm)) {
      failureToast("Please Delete or Save current changes");
    } else {
      startEditing(params?.id, params?.row);
    }
  };

  const handleCancelClick = async (params) => {
    stopEditing(params?.id);

    if (params?.row?.isNew) {
      setRowData(apiResponse);
      setRowForm({});
    }
  };

  const deleteRow = (rowId) => {
    if (window.confirm("Are you sure you want to delete this State?")) {
      setIsLoading(true);
      putpost2(
        `${endpoint?.subject.delete}/` + rowId,
        (data) => {
          successToast(data["message"]);
          setisSaveVisible(false);
          // setRowData(rowData.filter((obj) => obj.id !== rowId));
          setApiResponse(apiResponse.filter((obj) => obj.id !== rowId));
        },
        (data) => {
          failureToast(data["message"]);
        },
        "Delete"
      );

      setIsLoading(false);
    }
  };

  const saveAll = async (rowId) => {
    if (!rowForm["subjectDispValue"] || !rowForm["subjectDispValue"].trim()) {
      failureToast("Please enter the value of Display value");
      return;
    } else if (!REGEX_DISP_VAL.test(rowForm["subjectDispValue"])) {
      failureToast(
        "Only letters, numbers, spaces, hyphens (-), and ampersands (&) are allowed in Display value."
      );
      return;
    } else if (
      rowForm["subjectDesc"] === null ||
      !rowForm["subjectDesc"].trim()
    ) {
      failureToast("Please enter the value of subjectDesc");
      return;
    }

    const modifiedPayload = {
      subjectDispValue: rowForm.subjectDispValue,
      subjectDesc: rowForm.subjectDesc,
      status: rowForm.status,
    };

    setIsLoading(true);
    if (rowForm?.isNew) {
      putpost(
        endpoint?.subject.create,
        (data) => {
          successToast(data["message"]);
          setisSaveVisible(false);
          stopEditing(rowId);

          setApiResponse([...apiResponse, data.data]);
        },
        (data) => {
          failureToast(data["message"]);
        },
        modifiedPayload,
        "post"
      );
    } else {
      putpost(
        `${endpoint?.subject.update}/` + rowId,
        (data) => {
          successToast(data["message"]);
          setisSaveVisible(false);
          stopEditing(rowId);

          setApiResponse(
            apiResponse.map((obj) => (obj.id === rowId ? data.data : obj))
          );
        },
        (data) => {
          failureToast(data["message"]);
        },
        modifiedPayload,
        "put"
      );
    }
    setIsLoading(false);
  };

  const nextButtonHandler = (pageNum, updatedPageSize) => {
    setCurrentPage(pageNum);
    setPageSize(updatedPageSize);

    fetchAllSubjects(pageNum, updatedPageSize);
  };

  const searchInputHandler = (value = userSearchInput) => {
    fetchAllSubjects(0, pageSize, value);
  };

  const handleOnUserInput = (value) => {
    setUserSearchInput(value);
    if (value === "" && userSearchInput !== "") searchInputHandler(value);
  };

  const onKeyDownHandler = (e) => {
    if (e.key === "Enter" || e.keyCode === 13) {
      searchInputHandler();
    }
  };

  return (
    <>
      <Container className="mt-3" fluid>
        <Row>
          <div className="col">
            <Card>
              <div className="border-0 p-4">
                <div className="w-100 d-flex justify-content-between align-items-center">
                  <div
                    className={`d-flex align-items-center`}
                    style={{ height: "min-content" }}
                  >
                    <BackIcon
                      className="mr-2 large-text"
                      onClick={() => history.goBack()}
                    />
                    <div className="heading-3 color-black-60 text-bold">
                      Subject Master
                    </div>
                  </div>

                  <div className="d-flex justify-content-center align-items-center">
                    <AInput
                      placeholder="Search"
                      className=""
                      value={userSearchInput}
                      handler={handleOnUserInput}
                      onKeyDown={onKeyDownHandler}
                      crossIcon={false}
                      searchIcon={true}
                      style={{ width: "300px" }}
                      customSearchIconStyle={{ left: "5px" }}
                    />

                    <CustomButton
                      className={
                        "mb-0" + isSaveVisible ? " btn-dark cursor-gray" : null
                      }
                      content={"Add New"}
                      permissionType={"C"}
                      icon={true}
                      onClick={() => {
                        newRow();
                      }}
                      forTable
                      permissionSet={userPermissions}
                    />
                  </div>
                </div>
              </div>

              <div style={{ height: "72vh", maxHeight: "75vh" }}>
                <ADataGrid
                  removeWrapperContainer
                  rowModesModel={rowModesModel}
                  rows={rowData || []}
                  columns={columns}
                  rowId={(row) => row.id}
                  rowHeight={50}
                  loading={false}
                  rowCount={totalRows}
                  nextButtonHandler={nextButtonHandler}
                  currentPage={currentPage}
                  // components={{
                  //   NoRowsOverlay: () => (
                  //     <NoRowOverlay message={isLoading ? "Loading..." : null} />
                  //   ),
                  // }}
                  //   sx={gridStyles}
                  pinLastColumn
                  paginationModel={{
                    page: currentPage,
                    pageSize: pageSize,
                  }}
                />
              </div>
            </Card>
          </div>
        </Row>
      </Container>
    </>
  );
};

export default SubjectTable;
